module.exports = {
  paper: {
    background: 'palette.surface',
    shadow: 'shadow.sm',
    borderRadius: 'spacing.xxs',
    padding: 'spacing.md',
  },
  borderColor: 'palette.surface',
  transition: {
    duration: '200ms',
  },
};
